import { useEffect, useState } from "react";
import { db } from "../config/firebase";
import { collection, query, where, getDocs, doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../context/AuthContext";

export default function AdminApprovals() {
  const { user } = useAuth();
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  async function loadPending() {
    setLoading(true);
    const q = query(collection(db, "users"), where("role", "==", "customer"), where("status", "==", "pending"));
    const snap = await getDocs(q);
    setPending(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    setLoading(false);
  }

  useEffect(() => { loadPending(); }, []);

  async function decide(uid, decision) {
    await updateDoc(doc(db, "users", uid), {
      status: decision, // "approved" | "rejected"
      approvedBy: user.uid,
      approvedAt: serverTimestamp()
    });
    setPending(prev => prev.filter(p => p.id !== uid));
  }

  if (loading) return <p>Loading pending accounts...</p>;
  if (pending.length === 0) return <p>No pending customer accounts.</p>;

  return (
    <div className="admin-approvals">
      <h2>Pending Customer Accounts ({pending.length})</h2>
      <table>
        <thead>
          <tr><th>Company</th><th>Contact</th><th>Phone</th><th>Email</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {pending.map(p => (
            <tr key={p.id}>
              <td>{p.companyName}</td>
              <td>{p.name}</td>
              <td>{p.phone}</td>
              <td>{p.email}</td>
              <td>
                <button onClick={() => decide(p.id, "approved")}>Approve</button>
                <button onClick={() => decide(p.id, "rejected")}>Reject</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
